export default async (value) => typeof value === 'undefined'
